import { createContext } from 'react';

const ListContext = createContext<{
  listFixed?: boolean;
  listFocused: boolean;
  listLength: number;
  listIndex: number;
  setListIndex: (newIndex: number, increment?: number) => void;
  focusedByParent: boolean;
}>({
  listFixed: false,
  listFocused: false,
  listLength: 0,
  listIndex: -1,
  setListIndex: () => null,
  focusedByParent: true,
});

export default ListContext;
